import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem } from "./Components";

import bio_age_haz_lev from "../img/sswpIcons/BiologicalAgents/bio_age_haz_lev.png";
import bio_age_cov_cut from "../img/sswpIcons/BiologicalAgents/bio_age_ris_ass_pla_saf.png";
import bio_age_lit from "../img/sswpIcons/BiologicalAgents/bio_age_lit.png";
import bio_age_per_to_wor from "../img/sswpIcons/BiologicalAgents/bio_age_per_to_wor.png";
import bio_age_ris_ass from "../img/sswpIcons/BiologicalAgents/bio_age_ris_ass_pla_sa.png";
import bio_age_was_han from "../img/sswpIcons/BiologicalAgents/bio_age_was_han.png";
import bio_age_saf_dat from "../img/sswpIcons/BiologicalAgents/bio_age_saf_dat.png";
import bio_age_sto_lav from "../img/sswpIcons/BiologicalAgents/bio_age_sto_lab.png";
import bio_age_no_eat from "../img/sswpIcons/BiologicalAgents/bio_age_no_eat.png";
import bio_age_ven from "../img/sswpIcons/BiologicalAgents/bio_age_ven.png";

const json = {
    icon: bio_age_haz_lev,
    name: "Biological Agents",
    text: (
        <ul>
            <ListItem text="This covers exposure to bacteria, viruses, parasites, fungi and Weil’s disease" />
            <ListItem text="Thoroughly examine the area to assess the risk" />
            <ListItem text="Ensure people who are exposed to these risks have been vaccinated (eg. Hepatitis). If appropriate, use a permit to work system to control access to the effected area." />
            <Li>
                <Typography variant="title">
                    All operatives must wear PPE
                </Typography>
                <ol>
                    <ListItem text="Gloves" />
                    <ListItem text="Mask" />
                    <ListItem text="Overalls" />
                </ol>
            </Li>
            <ListItem text="After use, dispose of discarded PPE safely." />
        </ul>
    ),
    icons: {
        bio_age_saf_dat: {
            name: "Safety Data Sheet",
            icon: bio_age_saf_dat,
            text: (
                <ul>
                    <ListItem text="You must have a copy of the SDS sheet available to you on site for any substance/chemical that you are using. You must be aware and familiar with the information it contains before you use the substance/chemical." />
                    <Li>
                        <Typography variant="title">
                            In particular, be familiar with the following
                            sections
                        </Typography>
                        <ol>
                            <ListItem text="Hazard Identification" />
                            <ListItem text="First Aid Measures" />
                            <ListItem text="Fire-fighting measures" />
                            <ListItem text="Accidental release measures" />
                            <ListItem text="Handling & Storage" />
                            <ListItem text="Exposure controls/ personal protection" />
                            <ListItem text="(Any flash points/ boiling points)" />
                            <ListItem text=" Disposal considerations" />
                            <ListItem text="Transport information" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        bio_age_sto_lab: {
            name: "Storage/ Labels",
            icon: bio_age_sto_lav,
            text: (
                <ul>
                    <ListItem text="You must follow the instructions on any substance storage labels. You should have and follow the instructions of the SDS sheets." />
                </ul>
            )
        },

        bio_age_ris_ass: {
            name: "Risk Assess & Plan Safe Method",
            icon: bio_age_ris_ass,
            text: (
                <ul>
                    <ListItem text="Every work activity needs to be risk assessed prior to commencing. Identify potential hazards. Assess the likelihood of something happening, and the severity if something did go wrong. Select appropriate controls that will be put in place before the activity begins." />
                </ul>
            )
        },
        bio_age_cov_cut: {
            name: "Cover Cuts",
            icon: bio_age_cov_cut,
            text: (
                <ul>
                    <ListItem text="Any operative with open cuts must cover them with waterproof bandages/ dressing prior to commencing work. This is additional to wearing gloves etc." />
                    <ListItem text="Hands must be thoroughly washed prior to replacing or removing any bandages/ dressings." />
                </ul>
            )
        },
        bio_age_no_eat: {
            name: "No Eating",
            icon: bio_age_no_eat,
            text: (
                <ul>
                    <ListItem text="Where work activities expose operatives to risks involving chemical, biological, bacterial or viral risks, operatives should only eat or drink after thoroughly cleaning their hands during break periods. They should not eat, drink or smoke during work activities." />
                </ul>
            )
        },
        bio_age_ven: {
            name: "Ventilation",
            icon: bio_age_ven,
            text: (
                <ul>
                    <ListItem text="This control is where an engineered ventilation system is provided" />
                    <Li>
                        <Typography variant="title">
                            This can be of 2 types{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Negative Pressure Enclosures. This involves the building of an enclosure to contain the substance, gas, agent. Negative pressure units are installed within the enclosure to ensure all air flows into the enclosure, and that contained air cannot escape. It is often used for asbestos." />
                            <ListItem text="Local Exhaust Ventilation (LEV). This is an engineered system that captures harmful substances locally, at the emission point. It is often used for fumes, dust, spray." />
                        </ol>
                    </Li>
                    <ListItem text="The system needs to be installed by a competent person and certify that it is fit for purpose and for the intended emissions. It will require a thorough examination at least every 14 months, or shorter if specified by manufacturer." />
                    <ListItem text=" Negative Pressure enclosures must be operated to a strict and site specific method statement. They require a permit to enter system. Workers will have to undergo a decontamination procedure on leaving the enclosure." />
                    <ListItem text="Where LEVs are provided, they must be used by workers. The hood must be large enough, and the extraction air flow strong enough, to capture the emission. LEV hoods must be positioned by the worker to entrain/contain the emission at source. They should have an airflow meter that indicates correct operation. This must be checked by the worker before beginning the task. As a rule, at one ducting diameter distance from the opening, the air flow will be reduced to 10% of the total volume." />
                    <ListItem text="Workers must be clear on the limitation of LEVs and the requirement for other risk controls selected, including breathing PPE." />
                    <ListItem text="For Large system LEVs (where workers are within a ventilation zone), work should be organised such that the worker’s body, or other solid objects, are NOT placed in the air flow path, as this will obstruct flow and generate dead areas." />
                    <ListItem text="The ducting for both systems needs regular visual inspection, for damage, denting, couplings, or leaks. Filters should also be inspected regularly and replaced/cleaned in accordance with the manufacturer instructions." />
                </ul>
            )
        },
        bio_age_lit: {
            name: "Litter Picker",
            icon: bio_age_lit,
            text: (
                <ul>
                    <ListItem text="Work in teams or use lone working controls." />
                    <ListItem text="Use proper manual handling techniques." />
                    <ListItem text="Any cuts must be covered by waterproof plaster, even if wearing gloves." />
                    <ListItem text="Wear high visibility vests." />
                    <ListItem text="Long grabs devices should be used along with bags. Never touch litter with your hands." />
                    <ListItem text="If syringes are a risk designated containers for disposal must be provided." />
                    <ListItem text="Unidentified cans or canisters, oil drums, poisons, insecticides, clinical waste, broken glass, condoms, or other hazardous waste should be kept separate from other waste items." />
                </ul>
            )
        },
        bio_age_was_han: {
            name: "Wash Hands",
            icon: bio_age_was_han,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            You should wash your hands{" "}
                        </Typography>
                        <ul>
                            <ListItem text="At the end of your shift (or during shift if your hands become heavily soiled)" />
                            <ListItem text="before eating or preparing food, even snacks or drinking fluids" />
                            <ListItem text="After using the toilet" />
                            <ListItem text="After handling rubbish" />
                            <ListItem text="After handling animals" />
                        </ul>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            To wash your hands properly
                        </Typography>
                        <ul>
                            <ListItem text="Wet your hands with clean, running water, turn off the tap" />
                            <ListItem text="Apply soap and lather well for 20 seconds (or longer if dirt is ingrained)" />
                            <ListItem text="Rub hands together rapidly across all surfaces of your hands and wrists. Don’t forget the back of your hands, or ensure you remove rings to wash under them." />
                            <ListItem text="Rinse well under running water and make sure all soap is removed" />
                            <ListItem text="Dry your hands with a clean towel or air dry them. Best results come from using paper towels/single use towels" />
                            <ListItem
                                text="Wash and dry under any rings, to prevent cross contamination.
"
                            />
                        </ul>
                    </Li>
                </ul>
            )
        },
        bio_age_per_to_wor: {
            name: "Permit To Work",
            icon: bio_age_per_to_wor,
            text: (
                <ul>
                    <ListItem text="This formal system ensures the required controls are in place before beginning a task with a high risk hazard." />
                    <ListItem text="The permit system identifies the controls that must be in place to allow the task to begin. The implementation of these controls must be signed off by an appointed seperate individual, before an operative is permitted to begin the task." />
                    <ListItem text="The permit system should also state the conditions to be met after work is completed and be signed off by the operative (and verified by the appointed individual)." />
                </ul>
            )
        }
    }
};

export default json;
